import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Dialog as DialogComponent } from '@lean-body/components/molecules';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { ButtonType, Button } from '../atoms';
export const QuitCourseLessonDialog = ({ onClickContinue, onClickQuit }) => {
    return (React.createElement(DialogComponent, { onClickCancel: onClickContinue, disableBackgroundCancel: true, classObject: styles.dialog, content: React.createElement("div", { className: css(styles.container) },
            React.createElement("img", { className: css(styles.image), src: "/assets/images/dialog/sabo_crying.png", alt: "" }),
            React.createElement("div", { className: css(styles.title) }, "\u30EC\u30C3\u30B9\u30F3\u3084\u3081\u3061\u3083\u3046\u306E\uFF1F"),
            React.createElement(Button, { buttonType: ButtonType.primary, className: css(styles.button, styles.continueButton), onClick: onClickContinue, isRadius: true },
                React.createElement("div", { className: css(styles.continueButtonText) }, "\u3084\u3063\u3071\u308A\u7D9A\u3051\u308B")),
            React.createElement(Button, { buttonType: ButtonType.transparentBackgroundPrimary, className: css(styles.button, styles.quitButton), onClick: onClickQuit, isRadius: true },
                React.createElement("div", { className: css(styles.quitButtonText) }, "\u7D42\u4E86"))) }));
};
const styles = StyleSheet.create({
    dialog: {
        transform: 'none',
        width: '100%',
        top: 'unset',
        left: 0,
        bottom: 0,
        borderRadius: '44px 44px 0 0',
        backgroundColor: Colors.White,
        [MediaBreakPointUp.MD]: {
            transform: 'translate(-50%, -50%)',
            top: '50%',
            left: '50%',
            bottom: 'unset',
            maxWidth: 375,
            borderRadius: 44,
        },
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: Colors.White,
        padding: 24,
        borderRadius: 'inherit',
    },
    image: {
        width: 145,
        height: 146,
        objectFit: 'contain',
    },
    title: {
        marginTop: 8,
        color: Colors.Black,
        fontSize: 20,
        fontWeight: 700,
        lineHeight: 1.4,
        letterSpacing: '1.6px',
        textAlign: 'center',
    },
    button: {
        display: 'block',
        width: '100%',
        minHeight: 48,
        marginTop: 24,
    },
    continueButton: {
        marginTop: 24,
    },
    quitButton: {
        border: 'none',
        marginTop: 8,
    },
    continueButtonText: {
        fontSize: 16,
        fontWeight: 700,
        letterSpacing: '1.28px',
        color: Colors.White,
    },
    quitButtonText: {
        fontSize: 16,
        fontWeight: 700,
        letterSpacing: '1.28px',
        color: Colors.Alert,
    },
});
